export default () => {
  const pageReadyCode = () => {
    // Check if we're on the correct page type.
    const pdfPage = document.querySelector('[data-pdf-file-index]');
    if (!pdfPage) {
      return;
    }

    const pdfFiles = pdfPage.querySelectorAll('[data-pdf-file-button]');

    const pdfTitleToKebabCase = (title) => {
      // replace " - " with "-"

      return title.toLowerCase().replace(/ - /g, '-').replace(/ /g, '-');
    };

    // Handle button click
    pdfFiles.forEach((pdfFile, index) => {
      pdfFile.addEventListener('click', (e) => {
        e.preventDefault();
        const category = pdfFile.getAttribute('data-category');
        const title = pdfFile.getAttribute('data-title');
        // go to the clicked pdf file page
        window.location.href = `/resources/${category}/${pdfTitleToKebabCase(title)}`;
      });
    });

  };
  apos.util.onReady(pageReadyCode);
};
